/**
 * Formats a numeric amount as Indian Rupees with Indian digit grouping
 * (e.g. 343343 → "₹3,43,343"). Paise are shown only when present.
 */
export function formatINR(value: string | number | null | undefined): string {
  const n = typeof value === 'string' ? Number(value) : value;
  if (n == null || Number.isNaN(n)) return '₹0';
  return `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
